import { AspectRatio, Button, Stack, Text } from "@chakra-ui/react";
import React, { FC } from "react";

import {
  GatsbyImage,
  getImage,
  IGatsbyImageData,
  StaticImage,
} from "gatsby-plugin-image";
import { ArrowRightGreen } from "../../customIcons";

type BlogCardType = {
  imageData?: IGatsbyImageData;
  category?: string;
  title?: string;
  description?: string;
  date?: string;
  slug?: string;
  input?: boolean;
  authorSlug?: any;
};

const BlogCard: FC<BlogCardType> = ({
  imageData,
  category,
  title,
  description,
  date,
  slug,
}) => {
  const image = imageData ? getImage(imageData) : null;

  return (
    <Stack bg="#fff" gap={0}>
      <a href={`${slug}`} style={{ textDecoration: "unset" }}>
        <AspectRatio ratio={4 / 3}>
          {image ? (
            <GatsbyImage
              image={image}
              alt="Blog Featured Image"
              objectFit="cover"
              style={{
                height: "100%",
                width: "100%",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            />
          ) : (
            <StaticImage
              quality={100}
              src="../../../images/blogPlaceholder.png"
              alt="Blog Featured Image"
              objectFit="cover"
              layout="fullWidth"
              style={{
                height: "100%",
                width: "100%",
                backgroundColor: "transparent !important",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            />
          )}
        </AspectRatio>
      </a>

      <Stack gap={0} p={3}>
        {/* Category - Not clickable */}
        {category && (
          <Text
            lineHeight="140%"
            borderRadius="4px"
            fontSize={{ base: "14px", lg: "16px" }}
            w="max-content"
            bg="#CEE0DC"
            py="2px"
            px="8px"
            color="#116266"
            className="medium-text"
          >
            {String(category)
              .toLowerCase()
              .split(" ")
              .map((word, index) => {
                if (index === 1 && word.toUpperCase() === "EU") {
                  return "EU";
                }
                if (index === 2 && word.toLowerCase() === "mentions") {
                  return "mentions";
                }

                return word.charAt(0).toUpperCase() + word.slice(1);
              })
              .join(" ")}
          </Text>
        )}

        <Text
          pt={3}
          pb={1}
          className="medium-text"
          fontSize="14px"
          color="#6A7471"
        >
          {date}
        </Text>

        <a href={`${slug}`} style={{ textDecoration: "unset" }}>
          <Text
            className="grotesk-regular"
            fontSize="24px"
            lineHeight="100%"
            my={2}
            noOfLines={2}
            h={{ base: "unset", md: "48px" }}
            as="h3"
          >
            {title}
          </Text>
        </a>

        <Text
          mb={3}
          fontSize="16px"
          color="#6A7471"
          className="regular-text"
          noOfLines={2}
          dangerouslySetInnerHTML={{ __html: description as string }}
        />

        <a href={`${slug}`}>
          <Button
            pt={2}
            fontSize="16px"
            variant="link"
            bg="transparent"
            className="regular-text"
            _hover={{ bg: "transparent", color: "#4C9195" }}
            color="#116266"
            borderRadius="9999px"
            rightIcon={<ArrowRightGreen w="16px" h="16px" />}
          >
            Learn more
          </Button>
        </a>
      </Stack>
    </Stack>
  );
};

export default BlogCard;
